// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","active":"active-NEmi7","today":"today-2j7cJ","container":"container-2z4bi"};